


























/** @format */

import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import toTree from '@root/utils/to-tree';
@Component
export default class OrganizationSearch extends Vue {
  @Prop()
  value!: string[] | string | null;

  // 是否多选
  @Prop({
    type: Boolean,
    default: false
  })
  multiple!: boolean;

  // 是否可编辑
  @Prop({
    type: Boolean,
    default: false
  })
  disabled!: boolean;

  // 是否可编辑
  @Prop({
    type: Boolean,
    default: true
  })
  allowChildest?: boolean;

  // 最多展示tag树
  @Prop()
  maxTagCount!: number;

  // 是否默认展开树
  @Prop({
    type: Boolean,
    default: true
  })
  treeDefaultExpandAll!: boolean;

  // 定义选中项回填的方式。TreeSelect.SHOW_ALL: 显示所有选中节点(包括父节点). TreeSelect.SHOW_PARENT: 只显示父节点(当父节点下所有子节点都选中时). 默认只显示子节点.
  @Prop()
  showCheckedStrategy!: string;

  @Prop()
  getPopupContainer: Function;

  @Prop({
    type: Boolean,
    default: false
  })
  isOrgRoot: boolean; //是否默认选中根节点
  defaultExpandedArray: any[] = []; // 默认展开的节点

  innerValue: string[] | string | null = this.value || null;

  @Watch('value')
  onChangeValue(newValue: string[] | string | null) {
    this.innerValue = newValue;
  }

  /**
   *
   */
  handleChange() {
    this.$emit('input', this.innerValue);
    this.$emit('change', this.innerValue);
  }
  searchValue: string = '';
  onSearch(value) {
    this.searchValue = value;
  }
  //清空搜索的值
  clearSearchValue() {
    this.searchValue = '';
  }
  get computedTreeData() {
    let data;
    try {
      let state = this.$store.state,
        orgs = state.organizations.userOrg,
        newOrgs = [];

      let treeData = toTree(orgs, {
        idProp: 'id',
        parentProp: 'parentId',
        titleProp: 'name',
        keyFieldMap: 'value',
        titleFieldMap: 'title'
      });

      let disabledOrgs = [],
        availableOrgs = [];
      if (!this.allowChildest) {
        let disabledSomething = arr => {
          arr.forEach(d => {
            if (typeof d.children === 'undefined') {
              disabledOrgs.push(d);
              d.disabled = true;
            } else if (d.children.length > 0) {
              availableOrgs.push(d);
              disabledSomething(d.children);
            }
          });
        };

        this.$emit('syncDisabledNodes', disabledOrgs);
        this.$emit('syncAvailableNodes', availableOrgs);
        disabledSomething(treeData);
      }

      data = treeData;

      if (this.isOrgRoot) {
        this.$emit('selectDefaultRoot', treeData[0].id || '');
      }
    } catch (e) {
      console.error('computedTreeData error:', e);
      data = [];
    }

    return data;
  }

  created() {
    const [first = {}] = this.computedTreeData;
    if (!this.treeDefaultExpandAll && first && first.id) {
      this.defaultExpandedArray = [first.id];
    }
  }
}
